import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _RECEIVABLES_LABEL;

export var RECEIVABLES_TYPES = {
  CUSTOMER_PAYMENT: 'CUSTOMER_PAYMENT',
  CONTARCTS_IN_TRANSIT: 'CONTARCTS_IN_TRANSIT',
  REBATE: 'REBATE',
  FINANCE_RESERVE: 'FINANCE_RESERVE'
};
export var RECEIVABLES_LABEL = (_RECEIVABLES_LABEL = {}, _defineProperty(_RECEIVABLES_LABEL, RECEIVABLES_TYPES.CUSTOMER_PAYMENT, 'Customer Payment'), _defineProperty(_RECEIVABLES_LABEL, RECEIVABLES_TYPES.CONTARCTS_IN_TRANSIT, 'Contracts in Transit'), _defineProperty(_RECEIVABLES_LABEL, RECEIVABLES_TYPES.REBATE, 'REBATE'), _defineProperty(_RECEIVABLES_LABEL, RECEIVABLES_TYPES.FINANCE_RESERVE, 'Finance Reserve'), _RECEIVABLES_LABEL);
export var DATES_LABEL = {
  DEAL_DOCS_SUBMISSION: 'Deal docs submission to Business Office',
  REBATE_DOCS_SUBMISSION: 'Rebate docs submission to OEM',
  CONTRACT_DOCS_SUBMISSION: 'Contract docs submission to Lender',
  VEHICLE_DELIVERY: 'Vehicle Delivery',
  CUST_PAYMENT: 'Customer Payment'
};